import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { logOut, getAgendas, selectAgenda, promptCompleteAppointment, promptCancelAppointment, promptDialogClose, completeAppointment, cancelAppointment } from 'state/actions'
import { getLoggedUser, getAgendaList, getSelectedAgenda } from 'lib/reader'
import { enableTimeslotControl } from 'lib/helper'

import HomeScreen from 'components/_Screens/Home'
import AppointmentsReportContainer from 'containers/AppointmentsReport'
import AppointmentsControlContainer from 'containers/AppointmentsControl'
import AppointmentSessionContainer from  'containers/AppointmentSession'
import threeDRotation from 'material-ui/svg-icons/action/three-d-rotation'


class HomeContainer extends React.Component {

   constructor(props) {
      super(props)
      this.state = {
         folders: {
            historico: {
               label: 'Consultas',
               route: '/consultas',
               component: AppointmentsReportContainer,
               show: true
            },
            horarios:  {
               label: 'Agenda',
               route: '/controle',
               component: AppointmentsControlContainer,
               show: true
            },
            atendimento:  {
               label: 'Atendimento',
               route: '/atendimento',
               component: AppointmentSessionContainer,
               show: false,
            },
            onStartAppointment: this.onStartAppointment,
         },
         selectedFolder: 'historico',
         selectedAppointment: null
      }
      this.folderOptionSelected = this.folderOptionSelected.bind(this)
      this.onCompleteAppointment = this.onCompleteAppointment.bind(this)
      this.onCancelAppointment = this.onCancelAppointment.bind(this)
      this.onStartAppointment = this.onStartAppointment.bind(this)
      this.onSelectNewAgenda = this.onSelectNewAgenda.bind(this)
      this.selectAppointment = this.selectAppointment.bind(this)
   }

   onStartAppointment = (appointment) => {
      const { appointmentCode } = appointment.dtoReservedAppointment
      const { folders } = this.state
      this.setState({
         folders:{
            ...folders,
            atendimento:{
               ...folders.atendimento,
               show: true,
               label: `Atendimento - ${appointmentCode}`,
            },
         },
      })
      this.selectAppointment(appointment)
      this.folderOptionSelected('atendimento')
   }
   // Update url for selected option
   folderOptionSelected(selectedFolder) {
      const { folders } = this.state
      this.setState({selectedFolder : selectedFolder})
      this.props.history.replace(folders[selectedFolder].route)
   }

   selectAppointment(appointment){
      this.setState({ selectedAppointment: appointment })
   }

   onCompleteAppointment(id) {
      const { completeAppointment, promptDialogClose } = this.props
      completeAppointment({ id })
      promptDialogClose()
   }
   onCancelAppointment(id, extraNote) {
      const { cancelAppointment, promptDialogClose } = this.props
      cancelAppointment({ id, extraNote })
      promptDialogClose()
   }

   onSelectNewAgenda(agenda)
   {
      this.props.selectAgenda(agenda)
      this.setState({
         folders:{
            ...this.state.folders,
            atendimento:{
               ...this.state.folders.atendimento,
               show: false
            }
         }
      })
      this.selectAppointment(null)
      this.folderOptionSelected('historico')
   }

   render() {
      const { loggedUser, agendaList, selectedAgenda, folderMenus, ui, promptDialogClose } = this.props
      if (!loggedUser || !agendaList) return null

      const showControlTab = selectedAgenda ? enableTimeslotControl(selectedAgenda) : false

      return (
         <HomeScreen
            loggedUser={loggedUser}
            agendaList={agendaList}
            onAgendaSelect={this.onSelectNewAgenda}
            onRefreshAgendas={this.props.getAgendas}
            selectedAgenda={selectedAgenda}
            folderMenus={folderMenus}
            onOptionSelect={this.folderOptionSelected}
            onLogOut={this.props.logOut}
            showControlTab={showControlTab}
            ui={ui}
            onCloseConfirmOrCancelDialog={promptDialogClose}
            onConfirmAppointmentCompletion={this.onCompleteAppointment}
            onConfirmAppointmentCancelation={this.onCancelAppointment}
            folders={this.state.folders}
            selectedFolder={this.state.selectedFolder}
            selectedAppointment={this.state.selectedAppointment}
         />
      )
   }
}

HomeContainer.propTypes = {
   loggedUser: PropTypes.object,
   agendaList: PropTypes.array.isRequired,
   getAgendas: PropTypes.func.isRequired,
   logOut: PropTypes.func.isRequired,
   promptAppointment: PropTypes.object,
   ui: PropTypes.object,
}

const mapStateToProps = state => ({
   loggedUser: getLoggedUser(state),
   agendaList: getAgendaList(state),
   selectedAgenda: getSelectedAgenda(state),
   // folderMenus: getFolderMenus(state),
   ui: state.ui,
})

export default withRouter(connect(
   mapStateToProps,
   { logOut, getAgendas, selectAgenda, promptCompleteAppointment, promptCancelAppointment, promptDialogClose, completeAppointment, cancelAppointment }
)(HomeContainer))



// WEBPACK FOOTER //
// ./src/containers/Home/index.js